import { useAngularContext } from 'AngularContext';
import { useCurrentUser, useOfflineModeManager } from 'FrontRoyalAngular';
import { type AnyObject } from '@Types';
import { SUPPORTED_COURSE_TALK_STREAMS } from '../supportedCourseTalkStreams';
import { useIguanaUserFlags } from './useIguanaUserFlags';

// The CourseTalk review set for this course, or null. Hidden in the native app, offline, and for external-institution students.
export function useCourseTalk(streamId: string) {
    const currentUser = useCurrentUser();
    const offlineModeManager = useOfflineModeManager();
    const $injector = useAngularContext();
    const { hasExternalInstitution } = useIguanaUserFlags();

    const courseTalkId = SUPPORTED_COURSE_TALK_STREAMS[streamId];
    if (!courseTalkId || courseTalkId <= 0) return { courseTalkId: null };

    const $window = $injector.get<AnyObject>('$window');

    const isCourseTalkEnabled =
        !$window.CORDOVA && !offlineModeManager.inOfflineMode && !(currentUser && hasExternalInstitution);

    return { courseTalkId: isCourseTalkEnabled ? courseTalkId : null };
}
